import { LoaderIcon, Logo } from '@repo/icons';
import React, { ReactNode, useState } from 'react';
import cn from 'classnames';
import boxHead from '@app/img/login/community/box.png';
import orbHead from '@app/img/login/community/orb.png';
import pyramidHead from '@app/img/login/community/pyramid.png';
import { useImageLoadingCallback } from '@repo/hooks';
import { MessageButton, MessageButtonProps } from '@components/ViewMessage';
import styles from './ViewWrapper.module.scss';
import gradientBG from '@app/img/onboarding/gradient_bg.png';

const headImages = [boxHead, orbHead, pyramidHead];

export default function ViewWrapper({
  animateIn,
  loading,
  icon,
  headline,
  message,
  button,
}: {
  animateIn?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  headline?: ReactNode;
  message?: ReactNode;
  button?: MessageButtonProps;
}) {
  const [headImagesLoaded, setHeadImagesLoaded] = useState(false);
  useImageLoadingCallback(headImages, () => {
    setHeadImagesLoaded(true);
  });

  return (
    <div className={styles.viewWrapper}>
      <div className={styles.bgImageContainer}>
        <img src={gradientBG} className={styles.bgImage} />
      </div>
      <div className={styles.viewWrapperInner}>
        <div
          className={cn(
            styles.heads,
            !animateIn && styles.noAnimate,
            headImagesLoaded && animateIn && styles.loaded,
          )}
        >
          <img className={cn(styles.head, styles.box)} src={boxHead} draggable={false} />
          <img className={cn(styles.head, styles.pyramid)} src={pyramidHead} draggable={false} />
          <img className={cn(styles.head, styles.orb)} src={orbHead} draggable={false} />
        </div>
        <Logo className={styles.clayLogo} customColor="#fff" />
        <div className={styles.spinner}>{loading && <LoaderIcon customColor="#fff" />}</div>
        <div
          className={cn(styles.content, loading && styles.loading, animateIn && styles.animateIn)}
        >
          {icon && <div className={styles.icon}>{icon}</div>}
          {headline && <h4>{headline}</h4>}
          {message && <p>{message}</p>}
          {button && <MessageButton button={button} />}
        </div>
      </div>
    </div>
  );
}
